<template>
    <div>
      <HeadDetailsGama  :buttonsAccredited="true" :btnAnexDown="true" @dowload="dawnloadGrup" :titleHead="'Detalhe do Empreendimento'"></HeadDetailsGama>
      <b-modal ref="modalDetails" hide-footer :size="isPdf ? 'lg' : 'md' " id="modal-center" centered>
        <template #modal-title>
              <div class="d-flex w-100">
                <div class="header-title">{{ nomearquivo }} - {{ grupoarquivo }}</div>
              </div>
            </template>
        <div class="d-flex w-100" style="min-height: 400px; justify-content:space-between" v-if="!isPdf">
          <div class="d-flex align-items-center mr-4">
            <i class="fa fa-chevron-left iconLst" @click="testeBack"></i>
          </div>
          <div class="d-flex align-items-center">
            <i class="fas fa-spinner fa-spin" style="scale:4" v-if="imgDetails === ''"></i>
            <img v-else class="img-modal-details" :src="'data:image/jpeg;base64,' + imgDetails">
          </div>
          <div class="d-flex align-items-center ml-4">
            <i class="fa fa-chevron-right iconLst" @click="testeNext"></i>
          </div>
        </div>
        <div class="d-flex w-100" v-if="isPdf" style="justify-content:space-between">
          <div class="d-flex align-items-center mr-4">
            <i class="fa fa-chevron-left iconLst" @click="testeBack"></i>
          </div>
          <i class="fas fa-spinner fa-spin icon-carregar" style="scale:4" v-if="imgDetails === ''"></i>
          <div class="w-100"  v-if="imgDetails !== ''">
            <iframe
              style="overflow: hidden"
              id="testeFrame"
              scrolling="no"
              class="pdf-overview"
              :src="'data:application/pdf;base64,'+ imgDetails + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
            </iframe>
          </div>
          <div class="d-flex align-items-center ml-4">
            <i class="fa fa-chevron-right iconLst" @click="testeNext"></i>
          </div>
      </div>
      </b-modal>
      <div id="body-details" >
           <div id="head-details" class="pt-2">
             <div class="w-25 input-rela">
               <input @keyup="pesquisar" v-model="search" class="form-control  input-paddi w-100 h-100" placeholder="Pesquisar Mídias">
               <i class="fas fa-search icon-search"  aria-hidden="true"></i>
             </div>
             <!-- <div class="d-flex">
               <button v-on:click="dawnloadGrup"  v-b-tooltip title="Baixar as mídias"  class="btn-dowload"><i class="fas fa-download"></i></button>
             </div> -->
           </div>
           <div v-if="!searching">
             <div class="headerColapse">ZCorretor</div>
            <div class="containerScrool">
            <Colapseimage ref="colapseimage"  v-for="dataf in GetdataGruposMidias" v-bind:key="dataf.enum" :flAdd="verificarEditar(dataf.enum)" v-on:removeImg="removeImg" :posicaoEnumExclusao="posicaoEnumExclusao" :posicaoEnum="posicaoEnum" :isPdf="verificarPdf(dataf.enum)" v-bind:enterpriseid="data.id" v-on:imageDetails="imageDetails"   :group="dataf.enum" :id="dataf.enum.toString()" v-on:dawnload="dawnloadGrup(data.enum)" :title="dataf.descricao" :dataImg="getTypes(dataf.enum)">
              <input :disabled="getTypes(dataf.enum).length === 0 ? true : false" :id="'check' + dataf.enum" type="checkbox" class="check-title">
              <template v-slot:newPick>
                 <div
                  id="dropzone"
                  @dragenter.prevent.stop="onDragEnter"
                  @dragover.prevent.stop="onDragOver"
                  @drop.prevent.stop=""
                >

                  <div :class="`${isHover ? 'hover-class':''} img-body-dawnload`" id="draghover"  @dragleave.prevent.stop="onDragLeave" @drop.prevent="SendImage">
                    <div v-on:click="addImg" :id="dataf.enum.toString()" class="img-body-info"  >
                      <i class="fas fa-file-archive" :id="dataf.enum.toString()"></i>
                      <p class="mt-4" style="font-size: 20px" :id="dataf.enum.toString()">ADICIONAR ARQUIVO</p>
                    </div>
                    <input :multiple="true" v-on:change="SendImage" :accept="verificarPdf(dataf.enum) ? 'application/pdf':'image/png, image/jpeg, video/mp4'" :class="'addinput'" type="file" :id="'addinput-' + dataf.enum.toString()">
                    </div>
                  </div>
              </template>
           </Colapseimage>
            </div>
           </div>
            <div v-if="!searching">
             <div class="headerColapse">Meuz</div>
            <div class="containerScrool">
            <Colapseimage ref="colapseimage"  v-for="dataf in GetdataGruposMidiasZincorporacao" v-bind:key="dataf.enum" :flAdd="verificarEditar(dataf.enum)" v-on:removeImg="removeImg" :posicaoEnumExclusao="posicaoEnumExclusao" :posicaoEnum="posicaoEnum" :isPdf="verificarPdf(dataf.enum)" v-bind:enterpriseid="data.id" v-on:imageDetails="imageDetails"   :group="dataf.enum" :id="dataf.enum.toString()" v-on:dawnload="dawnloadGrup(data.enum)" :title="dataf.descricao" :dataImg="getTypes(dataf.enum)">
              <input :disabled="getTypes(dataf.enum).length === 0 ? true : false" :id="'check' + dataf.enum" type="checkbox" class="check-title">
              <template v-slot:newPick>
                 <div
                  id="dropzone"
                  @dragenter.prevent.stop="onDragEnter"
                  @dragover.prevent.stop="onDragOver"
                  @drop.prevent.stop=""
                >

                  <div :class="`${isHover ? 'hover-class':''} img-body-dawnload`" id="draghover"  @dragleave.prevent.stop="onDragLeave" @drop.prevent="SendImage">
                    <div v-on:click="addImg" :id="dataf.enum.toString()" class="img-body-info"  >
                      <i class="fas fa-file-archive" :id="dataf.enum.toString()"></i>
                      <p class="mt-4" style="font-size: 20px" :id="dataf.enum.toString()">ADICIONAR ARQUIVO</p>
                    </div>
                    <input :multiple="true" v-on:change="SendImage" :accept="verificarPdf(dataf.enum) ? 'application/pdf':'image/png, image/jpeg, video/mp4'" :class="'addinput'" type="file" :id="'addinput-' + dataf.enum.toString()">
                    </div>
                  </div>
              </template>
           </Colapseimage>
            </div>
           </div>
          <!-- <div v-if="!searching">
             <div class="headerColapse">Outros</div>
            <div class="containerScrool">
            <Colapseimage ref="colapseimage"  v-for="dataf in GetdataGruposMidiasOutros" v-bind:key="dataf.enum" :flAdd="verificarEditar(dataf.enum)" v-on:removeImg="removeImg" :posicaoEnumExclusao="posicaoEnumExclusao" :posicaoEnum="posicaoEnum" :isPdf="verificarPdf(dataf.enum)" v-bind:enterpriseid="data.id" v-on:imageDetails="imageDetails"   :group="dataf.enum" :id="dataf.enum.toString()" v-on:dawnload="dawnloadGrup(data.enum)" :title="dataf.descricao" :dataImg="getTypes(dataf.enum)">
              <input :disabled="getTypes(dataf.enum).length === 0 ? true : false" :id="'check' + dataf.enum" type="checkbox" class="check-title">
              <template v-slot:newPick>
                 <div
                  id="dropzone"
                  @dragenter.prevent.stop="onDragEnter"
                  @dragover.prevent.stop="onDragOver"
                  @drop.prevent.stop=""
                >

                  <div :class="`${isHover ? 'hover-class':''} img-body-dawnload`" id="draghover"  @dragleave.prevent.stop="onDragLeave" @drop.prevent="SendImage">
                    <div v-on:click="addImg" :id="dataf.enum.toString()" class="img-body-info"  >
                      <i class="fas fa-file-archive" :id="dataf.enum.toString()"></i>
                      <p class="mt-4" style="font-size: 20px" :id="dataf.enum.toString()">ADICIONAR ARQUIVO</p>
                    </div>
                    <input :multiple="true" v-on:change="SendImage" :accept="verificarPdf(dataf.enum) ? 'application/pdf':'image/png, image/jpeg, video/mp4'" :class="'addinput'" type="file" :id="'addinput-' + dataf.enum.toString()">
                    </div>
                  </div>
              </template>
           </Colapseimage>
            </div>
           </div> -->
           <div v-else class="img-flex pt-4">
             <div  v-for="dataimg in midiasSearch" v-bind:key="dataimg.id" class="p-3" >
               <div  class="img-body">
                 <div class="h-100" v-on:click="imageDetails(dataimg.id, dataimg.arquivo.extensao)">
                      <div class="img-view">
                        <i v-if="dataimg.arquivo.extensao == 'pdf'" style="font-size: 70px" class="fas fa-file-pdf icone"></i>
                      <i v-else-if="dataimg.arquivo.extensao == 'mp4'" style="font-size: 70px" class="fas fa-video icone"></i>
                      <i v-else style="font-size: 70px" class="far fa-image icone"></i>
                      </div>
                      <div  class="img-footer">
                        <div class="img-title">{{dataimg.arquivo.descricao == null ? 'N/D' : dataimg.arquivo.descricao}}</div>
                    </div>
                  </div>
                  <div class="edit-img" v-on:click="removeImg(dataimg)" >
                    <i class="fas fa-times"></i>
                  </div>
               </div>
              </div>
           </div>
      </div>
  </div>
</template>

<script>
import Boardmediaenterprise from './boardmediaenterprise'
export default Boardmediaenterprise
</script>

<style scoped>
.icon-carregar{
  margin: 2rem;
}
.headerColapse{
    background-color: #008148;
    height: 2rem;
    border-radius: 10px 10px 0px 0px;
    margin-top: 1rem;
    color: rgb(254 254 254);
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
    line-height: 30px;
}
@media (min-width: 900px) and (max-width: 1280px){
  .containerScrool {
    background-color: rgb(249 249 249);
    padding: 10px;
    border-radius: 0px 10px 10px 10px;
    height: 100%;
  }
}
@media (min-width: 1281px) {
  .containerScrool {
    background-color: rgb(249 249 249);
    padding: 10px;
    border-radius: 0px 10px 10px 10px;
    height: 100%;
  }
}
.edit-img:hover{
   background-color: rgb(219, 7, 7);
}

.pencil-icon{
  z-index: 10;
}
.img-body:focus{
  transform: scale(1.5);

}
.img-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 75%;
  overflow: hidden;
}
.img-view{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-body-pdf{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  transition: 400ms;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.img-flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.img-body-info{
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.pdf-body-add{
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-body-body{
  position: relative;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
  z-index: 0;
}

.img-body{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  position: relative;
  transition: 400ms;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;

}
.img-body:hover{
  transform: scale(1.1);
}
.edit-img{
  height: 34px;
  top: 0px;
  z-index: 5;
  right: 0px;
  width: 40px;
  color: white;
  background-color: red;
  border-radius: 0px 8px 0px 15px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-footer{
  position: absolute;
  width: 100%;
  height: 30px;
  color: white;
  background: rgba(0, 0, 0, 0.644);
  bottom: 0px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.addinput{
  height: 100%;
  width: 100%;
  position: absolute;
  visibility: hidden;
}
.modal-body{
  height: 100%;
  width: 100%;
  background: #01683a;
}

.img-body-dawnload.hover-class{
  background-color: #01683a8a;
  transition: .5s;
  color: white;
}

.img-body-dawnload{
  margin-left: 7%;
  width: 270px;
  height: 185px;
  font-size: 50px;
  color: grey;
  border-radius: 10px;
  position: relative;
  flex-direction: column;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px dotted grey;
  transition: .5s;
}
.img-modal-details{
  height: 400px;
  object-fit: cover;
  width: 100%;
}
#head-details{
  display: flex;
  justify-content: space-between;
}

.btn-new-gru{
  height: 30px;
  width: 181px;
  background: white;
  font-size: 14px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
}
.btn-new-gru:hover{
  color: white;
  background: #008148;
}

.check-title{
  height: 20px;
  width: 20px;
  position: absolute;
  top: 8px;
  left: 5px;
  padding-left: 20px;
}
.btn-dowload{
  height: 30px;
  width: 53px;
  background-color: #008148;
  border: none;
  color: white;
  border-radius: 6px;
}
.btn-dowload:hover{
  background-color: #01683a;
}
.input-rela{
  position: relative;
}
.icon-search{
  position: absolute;
  top:  10px;
  left: 10px;
}
.input-paddi{
  padding-left: 28px;
}
.modal-body{
  padding: 0px;
  background: transparent;
}

.pdf-overview{
    height: 657px;
    width: 100%;
    overflow: auto;
}
.pdf-overview::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 0 0 0 10px;
}
.pdf-overview::-webkit-scrollbar {
    width: 6px;
    background: #F4F4F4;
    border-radius: 0 0 0 10px;
}
.pdf-overview::-webkit-scrollbar-thumb {
    background: #dad7d7;
    border-radius: 0 0 0 10px;
}

  .header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.popUp{
  background-color: red;
}
.iconLst{
  scale: 4;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/boardmediaenterprise/boardmediaenterprise.vue